import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "vdmar_panel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("legend", null, "АВТОРИЗАЦИЯ", -1)
const _hoisted_7 = { class: "vdmar_authorization" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "login" }, " Логин ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, " Пароль ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " Войти ", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("fieldset", {
            class: "vdmar_fieldset",
            style: _normalizeStyle(_ctx.styleObject)
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "login",
                  type: "login",
                  name: "login",
                  required: "",
                  autofocus: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userLoginPost.username) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userLoginPost.username]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  type: "password",
                  name: "password",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userLoginPost.password) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userLoginPost.password]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSubmit()))
                }, _hoisted_11)
              ])
            ])
          ], 4)
        ])
      ]))
}